import LegalLayout, { LEGAL_META } from "./LegalLayout";

const { COMPANY, CONTACT_EMAIL } = LEGAL_META;

export default function Terminos() {
  return (
    <LegalLayout
      title="Términos y Condiciones de Uso"
      subtitle={`Estos términos regulan el acceso y uso de la plataforma SIGSAOP, operada por ${COMPANY}. Al ingresar o utilizar la plataforma, aceptas íntegramente estas condiciones.`}
    >
      <h2>1. Identificación del proveedor</h2>
      <p>
        La plataforma SIGSAOP (en adelante, "la Plataforma") es desarrollada, operada y comercializada por <strong>{COMPANY}</strong>,
        con domicilio en Chile, y puede ser contactada en <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>.
      </p>

      <h2>2. Descripción del servicio</h2>
      <p>
        SIGSAOP es una aplicación web tipo SaaS (Software as a Service) que centraliza y gestiona la información relacional
        de las organizaciones con comunidades, autoridades, compromisos socioambientales, proyectos, inversión social, RCA
        (Resoluciones de Calificación Ambiental) y actividades del territorio. La plataforma se entrega bajo el modelo
        multi-tenant, donde cada cliente cuenta con un espacio aislado de datos.
      </p>

      <h2>3. Registro y cuenta de usuario</h2>
      <p>
        El acceso a la Plataforma requiere una cuenta corporativa asignada por el administrador de tu organización o por
        {" "}{COMPANY}. El usuario se obliga a:
      </p>
      <ul>
        <li>Proporcionar información veraz, actualizada y completa.</li>
        <li>Custodiar sus credenciales y no compartirlas con terceros.</li>
        <li>Notificar inmediatamente cualquier uso no autorizado de su cuenta.</li>
        <li>Utilizar la Plataforma únicamente para los fines legítimos autorizados por su organización.</li>
      </ul>

      <h2>4. Licencia de uso</h2>
      <p>
        {COMPANY} otorga al Cliente una licencia limitada, no exclusiva, no transferible y revocable para utilizar la
        Plataforma durante la vigencia del contrato comercial. Esta licencia no implica transferencia de propiedad
        intelectual alguna.
      </p>

      <h2>5. Propiedad intelectual</h2>
      <p>
        El código fuente, diseño, marcas, logotipos, textos, imágenes y demás elementos de la Plataforma son propiedad
        exclusiva de {COMPANY} o de sus licenciantes, y están protegidos por la legislación chilena e internacional
        aplicable. Los datos ingresados por el Cliente ("Datos del Cliente") permanecen de propiedad del Cliente.
      </p>

      <h2>6. Obligaciones del usuario</h2>
      <p>El usuario se compromete a NO:</p>
      <ul>
        <li>Utilizar la Plataforma con fines ilícitos, contrarios a la moral, orden público o buenas costumbres.</li>
        <li>Intentar acceder a datos de otros clientes o vulnerar los mecanismos de seguridad.</li>
        <li>Realizar ingeniería inversa, descompilar o intentar obtener el código fuente.</li>
        <li>Introducir virus, malware, código malicioso o contenido que pueda dañar la Plataforma.</li>
        <li>Extraer masivamente información mediante scraping o bots no autorizados.</li>
      </ul>

      <h2>7. Disponibilidad y niveles de servicio</h2>
      <p>
        {COMPANY} se compromete a mantener la Plataforma disponible con un objetivo de uptime mensual del 99% (SLA
        comercial específico según contrato). No se garantiza ausencia total de interrupciones por mantenimiento
        programado, caídas de proveedores de infraestructura o eventos de fuerza mayor.
      </p>

      <h2>8. Responsabilidad y limitación</h2>
      <p>
        La Plataforma se entrega "tal cual" y "según disponibilidad". En la máxima medida permitida por la ley chilena,
        {" "}{COMPANY} no será responsable por daños indirectos, lucro cesante, pérdida de reputación, ni por decisiones
        adoptadas por el Cliente basándose en la información registrada por sus propios usuarios en la Plataforma. La
        responsabilidad total acumulada de {COMPANY} no excederá los montos efectivamente pagados por el Cliente durante
        los últimos 12 meses.
      </p>

      <h2>9. Protección de datos personales</h2>
      <p>
        El tratamiento de datos personales se rige por nuestra <a href="/privacidad">Política de Privacidad</a>, en
        cumplimiento de la Ley N° 19.628 sobre Protección de la Vida Privada y la Ley N° 21.719 que regula la
        protección y tratamiento de los datos personales en Chile.
      </p>

      <h2>10. Confidencialidad</h2>
      <p>
        {COMPANY} tratará como estrictamente confidencial toda la información y datos del Cliente cargados en la
        Plataforma, y aplicará medidas técnicas y organizativas apropiadas para su protección, incluyendo cifrado en
        tránsito y en reposo, control de accesos por rol y respaldos automatizados.
      </p>

      <h2>11. Pagos, planes y facturación</h2>
      <p>
        Las condiciones económicas, planes y facturación se rigen por el contrato comercial suscrito por separado. El
        impago habilita a {COMPANY} a suspender el servicio previa notificación por escrito con al menos 15 días de
        anticipación.
      </p>

      <h2>12. Modificaciones</h2>
      <p>
        {COMPANY} se reserva el derecho a modificar estos términos en cualquier momento. Los cambios serán notificados
        al Cliente vía email o mediante aviso destacado en la Plataforma con al menos 30 días de anticipación cuando
        afecten obligaciones sustanciales.
      </p>

      <h2>13. Terminación</h2>
      <p>
        Cualquiera de las partes podrá terminar el contrato con las condiciones acordadas comercialmente. Ante la
        terminación, el Cliente podrá solicitar la exportación de sus datos dentro de los 30 días siguientes, tras lo
        cual éstos serán eliminados de manera segura de nuestros sistemas activos.
      </p>

      <h2>14. Legislación aplicable y jurisdicción</h2>
      <p>
        Estos términos se rigen por las leyes de la República de Chile. Cualquier controversia derivada será sometida a
        la competencia de los tribunales ordinarios de justicia con asiento en la ciudad de Antofagasta, sin perjuicio
        de las normas de arbitraje que se pacten en el contrato comercial.
      </p>

      <h2>15. Contacto</h2>
      <p>
        Para cualquier consulta relacionada con estos términos, escríbenos a
        {" "}<a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>.
      </p>
    </LegalLayout>
  );
}
